// removed by extract-text-webpack-plugin
module.exports = {"form-type-checkbox":"form-type-checkbox","field-style-inline":"field-style-inline","form-type-radio":"form-type-radio","field-style-outline":"field-style-outline"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/BasicFields.scss
// module id = 7o1w
// module chunks = 0